import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTreeModule } from '@angular/cdk/tree';

import { TreeComponent } from './components/tree/tree.component';
import { OutletDirective } from './directives/outlet.directive';
import { ToggleDirective } from './directives/toggle.directive';
import { PaddingDirective } from './directives/padding.directive';
import { TreeNodeDirective } from './directives/tree-node.directive';
import { TreeNodeDefDirective } from './directives/tree-node-def.directive';

@NgModule({
  imports: [
    CommonModule,
    CdkTreeModule
  ],
  declarations: [
    TreeComponent,
    OutletDirective,
    ToggleDirective,
    PaddingDirective,
    TreeNodeDirective,
    TreeNodeDefDirective
  ],
  exports: [
    TreeComponent,
    OutletDirective,
    ToggleDirective,
    PaddingDirective,
    TreeNodeDirective,
    TreeNodeDefDirective
  ]
})
export class McRAITreeModule { }